import axios from "axios";

export const state = {
    reportserviceanalysis: [],
};

export const getters = {
    reportserviceanalysis: state => state.reportserviceanalysis,
};

export const mutations = {
    setReportServiceAnalysis(reportserviceanalysis, newValue) { state.reportserviceanalysis = newValue},
};

export const actions = {
    fetchReportServiceAnalysis({ commit }) {
        axios.get('/reportserviceanalysis').then(res => {
            commit('setReportServiceAnalysis', res.data.payments)
        })
    },
    filterReportServiceAnalysis({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportserviceanalysis";
        axios.post(url, formData).then((response) => {
            commit('setReportServiceAnalysis', response.data.payments)
        })
    },
};
